<template>
  <div class="row">
    <div class="product-description col-12 col-md fs-5 mt-5 mt-md-0 order-2 order-md-1">
      <h2 class="d-inline-block h5 lh-base text-bg-primary mb-4 p-2">{{ $t("description") }}</h2>
      <div
        class="product_description-inner"
        v-html="product.description.html"
      ></div>
    </div>
    <div class="col-12 col-md-auto mt-5 order-1 order-md-2 product-attributes">
      <table class="table table-borderless table-striped mb-0">
        <thead>
          <tr>
            <th class="text-bg-primary text-uppercase product-attribute-box" colspan="2">{{ product.name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(info, index) in product.information_attributes" :key="index">
            <th v-if="info.value != 'false'">{{ info.label }}</th>
            <td v-if="info.value != 'false'">{{ info.value }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isMobile, isTablet } from "mobile-device-detect";

import icondefault from '@/base/assets/imgs/files/default.png'
import iconcsv from '@/base/assets/imgs/files/csv.png'
import icondoc from '@/base/assets/imgs/files/doc.png'
import icondocx from '@/base/assets/imgs/files/docx.png'
import icongif from '@/base/assets/imgs/files/gif.png'
import iconjpeg from '@/base/assets/imgs/files/jpeg.png'
import iconjpg from '@/base/assets/imgs/files/jpg.png'
import iconpdf from '@/base/assets/imgs/files/pdf.png'
import iconpng from '@/base/assets/imgs/files/png.png'
import icontxt from '@/base/assets/imgs/files/txt.png'
import iconxls from '@/base/assets/imgs/files/xls.png'
import iconxlsx from '@/base/assets/imgs/files/xlsx.png'
import iconxml from '@/base/assets/imgs/files/xml.png'

//import VRuntimeTemplate from "v-runtime-template";
// import ProductReview from "./ProductReview.vue";
export default {
  icondefault, icondocx,iconcsv,icondoc,iconpdf,iconxls,iconxlsx,icongif,iconjpeg,iconjpg,iconpng,icontxt,iconxml,
  name: "DescriptionTab",
  components: {

    //VRuntimeTemplate
    // ProductReview,
  },
  computed: {
    ...mapGetters({
      product: "product/getCurrentProduct",
    }),
    isMobileScreen() {
      return isMobile;
    },
    isTabShow() {
      return isTablet;
    },
    getDownloadCounts() {
      return this.product.downloads.length;
    },

    productFullName() {
      let name = "";
      if (this.productBrand != "") name += this.productBrand + " ";
      if (this.productModel != "") name += this.productModel + " ";
      name += this.product.name;
      return name;
    },
    productBrand() {
      let productBrand = "";
      if (this.product.information_attributes) {
        const brand = this.product.information_attributes.find(
          (item) => item.attribute_code == "merk"
        );
        if (brand) {
          productBrand = brand.value;
        }
      }
      return productBrand;
    },
    productModel() {
      let productModel = "";
      if (this.product.information_attributes) {
        const model = this.product.information_attributes.find(
          (item) => item.attribute_code == "model_number"
        );
        if (model) {
          productModel = model.value;
        }
      }
      return productModel;
    },
  },
  async created() {

  },
  data: () => (
      {
      description: {
      details:
        "De Trani is een winterjack van Rogelli die speciaal is ontworpen voor de winter. Inmiddels al aan de sterk verbeterde versie 3.0. Het jack is winddicht en waterafstotend zodat je optimaal kunt presteren in koude weersomstandigheden. Voor optimaal comfort zijn er softshell stukken aan de voorkant en isolerend fleece aan de binnenvoering aangebracht. Aan de achterzijde zijn 3 zakjes.",
      features: [
        "Winddicht en waterafstotend",
        " Race pasvorm",
        " Warmte isolerend fleece binnenvoering",
        " Elastische band aan de pols",
        " Softshell stukken op de voorkant",
        " Silicone antislipstrip in de taille",
        " Extra rug- en borstzak met ritssluiting",
        "D.T. PENSTAR stof",
        "Lange rits",
        "Reflecterende accenten voor extra zichtbaarheid",
      ],
      moreInfo: [
        { category: "Productgroep", info: "Fietsjack winter" },
        { category: "Introductie jaar", info: "2018" },
        { category: "Gebruikte materialen", info: "100% polyester" },
        {
          category: "Temperatuuradvies",
          info: "Vanaf temperaturen onder het vriespunt",
        },
      ],
    },
    reviews: {
      noOfReviews: 15,
    },
  }),
  methods: {
    getFileIcon(filetype){
      switch (filetype) {
        case 'csv':
          return iconcsv
        case 'doc':
          return icondoc
        case 'docx':
          return icondocx
        case 'gif':
          return icongif;
        case 'jpg':
          return iconjpeg;
        case 'jpeg':
          return iconjpg;
        case 'pdf':
          return iconpdf;
        case 'png':
          return iconpng;
        case 'txt':
          return icontxt;
        case 'xls':
          return iconxls;
        case 'xlsx':
          return iconxlsx;
        case 'xml':
          return iconxml;
        default:
          return icondefault;
      }
    },
    scroll(elId) {
      document.getElementById(elId).scrollIntoView({
        behavior: "smooth",
      });
    },
    unescape(str){
      return str.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
    }
  },
};
</script>
